<template>
  <div class="inbox-conversation-fallback">
    <p v-if="redirecting">
      Opening conversation...
    </p>
    <p v-else>
      <a
        href="#"
        @click.prevent="navigateToInbox"
      >Open conversation in inbox</a>
    </p>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const redirecting = ref(false)

function getOptixParams() {
  const urlParams = new URLSearchParams(window.location.search)
  let clientId = urlParams.get('client_id') || urlParams.get('clientId') || ''
  let canvasUUID = urlParams.get('canvasUUID') || urlParams.get('canvas_uuid') || urlParams.get('canvasUuid') || 'dashboard'

  if (document.referrer) {
    try {
      const referrerParams = new URLSearchParams(new URL(document.referrer).search)
      if (!clientId) clientId = referrerParams.get('client_id') || referrerParams.get('clientId') || ''
      if (!canvasUUID) canvasUUID = referrerParams.get('canvasUUID') || referrerParams.get('canvas_uuid') || referrerParams.get('canvasUuid') || 'dashboard'
    } catch (_e) {}
  }

  return { client_id: clientId, canvasUUID }
}

function navigateToInbox() {
  const conversationId = route.query.conversation || new URLSearchParams(window.location.search).get('conversation')
  const params = getOptixParams()
  const url = conversationId ? `/inbox?conversation=${conversationId}` : '/inbox'

  const message = {
    command: 'ReplaceUrl',
    payload: {
      client_id: params.client_id || '',
      canvasUUID: params.canvasUUID || 'dashboard',
      url,
      reload: true
    }
  }

  try {
    // Send to top frame (Optix app) so it can navigate to inbox
    if (window.top && window.top !== window) {
      window.top.postMessage(message, '*')
    }
    window.parent.postMessage(message, '*')
    redirecting.value = true
  } catch (err) {
    console.error('Error navigating to inbox:', err)
  }
}

onMounted(() => {
  // Auto-redirect when in iframe (we're the conversation panel content that loaded the wrong app)
  if (window.self !== window.top) {
    redirecting.value = true
    navigateToInbox()
  }
})
</script>

<style scoped>
.inbox-conversation-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 24px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.inbox-conversation-fallback a {
  color: #2563eb;
  text-decoration: none;
}

.inbox-conversation-fallback a:hover {
  text-decoration: underline;
}
</style>
